import { createContext } from 'react';

const AlertContext = createContext(void 0);

AlertContext.displayName = 'context(Alert)';

export default AlertContext;